import { ajaxCall, formRequestData } from './ajaxService';

const constants = window.getConfig;
const ajaxPoDepartmentUrl = `${constants.ajax.baseUrl}/purchaseorders/dept`;
const ajaxAdminPoDepartmentUrl = `${constants.ajax.baseUrl}/admin/purchaseorders/dept`;

export const ajaxGetPoDepartments = () =>
  new Promise((res, rej) => {
    ajaxCall(ajaxPoDepartmentUrl, formRequestData(constants.ajax.methods.get, true, false))
      .then(res)
      .catch(rej);
  });

export const ajaxGetPoDepartment = (id) =>
  new Promise((res, rej) => {
    ajaxCall(`${ajaxPoDepartmentUrl}/${id}`, formRequestData(constants.ajax.methods.get, true, false))
      .then(res)
      .catch(rej);
  });

export const ajaxSavePoDepartment = (data) =>
  new Promise((res, rej) => {
    ajaxCall(`${ajaxAdminPoDepartmentUrl}/save`, formRequestData(constants.ajax.methods.post, true, false, data, true))
      .then(res)
      .catch(rej);
  });

export const ajaxDeletePoDepartment = (id) =>
  new Promise((res, rej) => {
    ajaxCall(`${ajaxAdminPoDepartmentUrl}/delete/${id}`, formRequestData(constants.ajax.methods.put, true, false))
      .then(res)
      .catch(rej);
  });
